import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import * as moment from 'moment';

@Component({
  selector: 'app-info-supp',
  templateUrl: './info-supp.component.html',
  styleUrls: ['./info-supp.component.css']
})
export class InfoSuppComponent implements OnInit {

  @Input() chantier;
  @Input() edit: Boolean;
  @Input() hidetitle: Boolean;
  @Input() listeagence;
  @Input() listeterritoire;
  @ViewChild('msg') msg;
  @ViewChild('horaireMidiJours') horaireMidiJours;
  error
  @Output() editfct = new EventEmitter<any>();
  @Output() createfct = new EventEmitter<any>();
  resultType: any[] = [];
  resultAgence: any[] = [];
  resultTerritoire: any[] = [];
  resultnatureProducteurHydrocarbure: any[] = [];
  typeTeritoire = '';
  agence = '';
  tarif = '';
  listCivilite = [];
  societe: any = {};
  listResultAgence = []
  siteUtilisateur: any = {};
  listJours = [
    { id: 2, libelle: 'Lundi' },
    { id: 3, libelle: 'Mardi' },
    { id: 4, libelle: 'Mercredi' },
    { id: 5, libelle: 'Jeudi' },
    { id: 6, libelle: 'Vendredi' },
    { id: 7, libelle: 'Samedi' },
    { id: 1, libelle: 'Dimanche' }
  ];

  listTypeCom : any[] = []

  loadingIndicator: Boolean = false

  constructor(public common: CommonService, private modalService: BsModalService) {
  }

  ngOnInit() {
    this.typeTeritoire = this.chantier['typeTerritoire'] ? this.common.getItem(this.listeterritoire, this.chantier['typeTerritoire'].id) : '';
    this.listeagence = this.listeagence || [];
    this.agence = this.chantier['agence'] ? this.common.getItem(this.listeagence, this.chantier['agence'].id) : '';
    this.tarif = this.chantier['type'] ? this.common.getItem(this.common.getType('typeClient'), this.chantier['type'].id) : '';
    this.societe = this.common.local.getObject('paramSociete') || {};
    const listSite = this.common.local.getObject('listeSite') || [];
    listSite.forEach(elt => {
      if (elt.id === this.common.user[2]) {
        this.siteUtilisateur = elt;
      }
    });
    this.searchType();
    this.searchAgence();
    this.searchTerritoire();
    this.searchNatureHydro();
    if(this.societe.detailChantier) {
      this.searchRepresentant();
    }

    this.resultnatureProducteurHydrocarbure.forEach(elt => {
      if (this.chantier['natureProducteurHydrocarbure'] && elt.id === this.chantier['natureProducteurHydrocarbure'].id) {
        this.chantier['natureProducteurHydrocarbure'] = elt;
      }
    });
    
    this.formatedlistHoraireMidiParJour();
  }




  addAgence() {
    this.createfct.emit();
  }

  editAgence() {
    this.editfct.emit(this.agence);
  }

  searchType(event?) {
    this.resultType = [{ id: 0, libelleObjetEntite: 'Aucun', libelle: 'Aucun' }];
    this.common.getType('typeClient').forEach(elt => {
      elt.libelleObjetEntite = elt.libelle;
      this.resultType.push(elt);
      if(this.chantier['type'] && (this.chantier['type'].id === elt.id)) {
        this.chantier['type'] = elt
      }
    });

  }

  searchRepresentant(event?) {
    this.listTypeCom =  [] ;
    this.common.getType('typeCom').forEach(elt => {
      elt.libelleObjetEntite = elt.libelle || '' ;
      this.listTypeCom.push(elt);
      if(this.chantier['representant'] && (this.chantier['representant'].id === elt.id)) {
        this.chantier['representant'] = elt
      }
    });
    if(this.listTypeCom.length) {
    this.chantier['representant'] = this.chantier['representant'] && this.chantier['representant'].id ? this.chantier['representant'] : this.listTypeCom[0]
    }
  }

  searchAgence(event?) {
    this.resultAgence = [{ id: 0, libelleObjetEntite: 'Aucun', libelle: 'Aucun' }];
    this.listeagence.forEach(elt => {
      elt.libelleObjetEntite = elt.nom;
      this.resultAgence.push(elt);
    });
  }


  searchInListAgence(event) {
    this.listResultAgence = [];
    const eventLowerCase = !!event ? event.normalize('NFD').toLocaleLowerCase() : '';
    if (event && eventLowerCase) {
      this.listeagence.forEach(elt => {
        const desc = elt.nom || '';
        const libelleToLowerCase = !!desc ? desc.normalize('NFD').toLocaleLowerCase() : '';
        if (libelleToLowerCase.startsWith(eventLowerCase)) {
          elt.libelleObjetEntite = elt.nom;
          this.listResultAgence.push(elt);
        }
      });
    } else {
      this.listResultAgence = this.resultAgence;
    }
  }

  searchTerritoire(event?) {
    this.resultTerritoire = [{ id: 0, libelleObjetEntite: 'Aucun', libelle: 'Aucun' }];
    this.listeterritoire.forEach(elt => {
      elt.libelleObjetEntite = elt.libelle;
      this.resultTerritoire.push(elt);
    });
  }

  searchNatureHydro(event?) {
    this.resultnatureProducteurHydrocarbure = [{ id: 0, libelleObjetEntite: 'Aucun', libelle: 'Aucun' }];
    const list = this.common.getType('natureProdHydro') || [];
    console.log(list)
    list.forEach(elt => {
      elt.libelleObjetEntite = elt.libelleObjetEntite || elt.libelle || '';
      this.resultnatureProducteurHydrocarbure.push(elt);
    });
  }

  searchCivilite(event?) {
    this.listCivilite = [];
    const list = this.common.getType('typeCivilite') || [];
    list.forEach(elt => {
      // if (elt.libelle.startsWith(event) || elt.libelle.toLowerCase().startsWith(event)) {
      elt.libelleObjetEntite = elt.libelle;
      this.listCivilite.push(elt);
      // }
    });
  }

  validerAccesWidgethoraireMidiJour() {
    const listJr = this.listJours;
    let listToSave = listJr.filter((el: any) => (el.heureFin && el.heuredebut));
    listToSave.forEach((elt: any) => {
      elt.heureFermeture = "01/01/1970" + " " + elt.heureFin + ":00"
      elt.heureOuverture = "01/01/1970" + " " + elt.heuredebut + ":00"
      elt.heureFermetureTmp = moment(elt.heureFermeture,"DD/MM/YYYY HH:mm:ss");
      elt.heureOuvertureTmp = moment(elt.heureOuverture,"DD/MM/YYYY HH:mm:ss");
      elt.jour = elt.id;
    });
    if(this.testValidation(listToSave, 0)) {
      this.chantier['listHoraireMidiParJour'] = listToSave;
      this.common.closeModal();
    }  
  }

  testValidation(list, i) {
    const lengthList = list.length - 1;
    if (lengthList >= i) {
      if (list[i].heureOuvertureTmp.isBefore(list[i].heureFermetureTmp)) {
        this.error = "L'heure de fermeture ne peut pas être avant l'heure d'ouverture";
        this.common.openModal(this.modalService, this.msg);
        return false;
      } else {
        i++;
        return this.testValidation(list, i);
      }
    } else {
      return true;
    }
  }

  formatedlistHoraireMidiParJour() {
    this.chantier['listHoraireMidiParJour'] = this.chantier['listHoraireMidiParJour'] || [];
    this.listJours.forEach((elt: any) => {
      this.chantier['listHoraireMidiParJour'].forEach(el => {
        if (elt.id === el.jour) {
          elt.jour = elt.id
          elt.heureFin = moment(el.heureFermeture, 'DD/MM/YYYY HH:mm:ss').format('HH:mm');
          elt.heuredebut = moment(el.heureOuverture, 'DD/MM/YYYY HH:mm:ss').format('HH:mm');
        }
      });
    })
    this.listJours = [...this.listJours]
  }

  openWidgetHoraireMidiJour() {
    this.common.openModal(this.modalService, this.horaireMidiJours);
  }

  changehoraireMidiParJour() {
    if (!this.chantier['horaireMidiParJour']) {
      delete this.chantier['listHoraireMidiParJour']
    }
  }
}
